import { Component, EventEmitter, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Equipment } from 'src/app/models/maintenance/equipment';
import { EndpointDictionary } from 'src/app/utils/endpoints-dictionary';
import {
  HttpService,
  MenuBreadCrumb,
  params,
  TableColumns,
  TableConfiguration,
} from 'brainloper-ui';
import { ModalCalendarComponent } from '../modal-calendar/modal-calendar.component';
import { Projection } from 'src/app/models/maintenance/projection';
import { CalendarEvent } from 'angular-calendar';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
    selector: 'app-scheduled',
    templateUrl: './scheduled.component.html',
    styleUrls: ['./scheduled.component.scss'],
    standalone: false
})
export class ScheduledComponent implements OnInit {


  recargarTablaProyeccionesOdometro: EventEmitter<any> =
    new EventEmitter<any>();
  public dataProyeccionesOdometro = []
  public configurationProyeccionesOdometro: TableConfiguration = {
    edit: false,
    add: false,
    delete: false,
    selectable: false,
    addPer: false,
    editPer: false
  }
  public columnasProyeccionesOdometro: Array<TableColumns<Projection>> = [
    {
      ID: 'code',
      label: 'Código',
      type: 'text',
      style: {
        textAlign: 'center'
      },
    },
    {
      ID: 'description',
      label: 'Descripción',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil'
      },
    },
    {
      ID: 'odometerFrequency',
      label: 'Frecuencia uso (horas/km/ciclos)',
      type: 'thousandSeparator',
      style: {
        textAlign: 'center'
      },
    },
    {
      ID: 'odometerLastMtto',
      label: 'Medidor última actividad (horas/km/ciclos)',
      type: 'thousandSeparator',
      style: {
        textAlign: 'center',
        movil: 'no-movil'
      },
    },
    {
      ID: 'currentOdometer',
      label: 'Medidor actual (horas/km/ciclos)',
      type: 'thousandSeparator',
      style: {
        textAlign: 'center',
        movil: 'no-movil'
      },
    },
    {
      ID: 'odometerNextMtto',
      label: 'Medidor próximo mantenimiento (horas/km/ciclos)',
      type: 'thousandSeparator',
      style: {
        textAlign: 'center'
      },
    },
    {
      ID: 'remainingOdometer',
      label: 'Restante',
      type: 'thousandSeparator',
      style: {
        textAlign: 'center'
      },
    }
  ]

  public rango: number = 10000

  public comboEquipos: Array<Equipment>;

  private urlComboEquipos: string = `${EndpointDictionary.Equipment.EQUIPMENT_COMBO}`;
  public urlGetTablaProyeccionesOdometro: string = `${EndpointDictionary.OdometerProjection.ODOMETER_PROJECTION_TABLE}`

  public paramsProyeccionesOdometro: Array<params> = [
    { id: 'equipmentId', value: '0' },
    { id: 'limit', value: this.rango },
  ];

  public filteredList: Array<any>;

  public equipoControl = new FormControl<string | Equipment>('');

  public filteredEquipos: Observable<Equipment[]>;

  public menuBreadCrumb: Array<MenuBreadCrumb> = [
    {
      name: "Inicio",
      router: '/inicio',
    },
    {
      name: "Calendario",
      current: true
    }]

  constructor(
    private http: HttpService,
    public dialog: MatDialog,

  ) { }

  ngOnInit(): void {
    this.combos()
  }

  async combos() {
    let res: Array<Equipment> = await this.http.getDataBody(
      `${this.urlComboEquipos}`,
      []
    );
    if (res) {
      res.unshift({ id: 0, code: 'Todos' });
      this.comboEquipos = res;
      this.filteredList = this.comboEquipos.slice();
      this.filteredEquipos = this.equipoControl.valueChanges.pipe(
        startWith(''),
        map(value => {
          const name = typeof value === 'string' ? value : value?.code;
          return name ? this._filterEquipos(name as string) : this.comboEquipos.slice();
        })
      );
    }

  }

  private _filterEquipos(name: string): Equipment[] {
    const filterValue = name.toLowerCase();
    return this.comboEquipos.filter(equipo =>
      equipo.code.toLowerCase().includes(filterValue)
    );
  }

  displayFn(equipo: Equipment): string {
    return equipo?.code ?? '';
  }

  selectTab($event: MatTabChangeEvent) {
    switch ($event.index) {
      case 0:
        break;
      case 1:
        //this.paramsProyeccionesOdometro = [{id: 'id_compania', value: this.storage.get<number>('id_compania')},{id:'id_equipo', valur:'0'},{id:'limite', value:'200'}]
        this.recargarTablaProyeccionesOdometro.emit();
        break;
      default:
        break;
    }
  }

  selectEquipo($event: MatAutocompleteSelectedEvent) {
    const equipo = $event.option.value as Equipment;
    this.paramsProyeccionesOdometro[0].value = equipo.id;
    this.recargarTablaProyeccionesOdometro.emit();
  }

  changeRango() {
    if(this.rango == null || this.rango <=0){
      return
    }
    this.paramsProyeccionesOdometro[1].value = this.rango
    this.recargarTablaProyeccionesOdometro.emit()
  }

  clickFilaProjection($event:Projection) {
    let size = 80
    if (screen.width < 400 || screen.height < 400) {
      size = 85
    }

    let calendarEvent: CalendarEvent = {
      title:"",
      start:null,
      id: $event.activityId
    }
    this.dialog.open(ModalCalendarComponent, {
      data: calendarEvent,
      width:'80%',
    })


  }
}
